
<template>
    <div class="d-ins">
        <p>What is the probability that the cab involved in the accident was blue?</p>
        <div class="target">
            <div class="answer">
              <strong>My Answer is {{ range }}%</strong>
            </div>
            <input type="range" class="custom-range" min="0" max="100" v-model="range" @change="updateRange()">
            <div class="answer-scale">
              <div class="s100 marking"><strong>100%</strong></div>
              <div class="s90 tick"><hr style="display:none"></div>
              <div class="s80 tick"><hr style="display:none"></div>
              <div class="s70 tick"><hr style="display:none"></div>
              <div class="s60 tick"><hr style="display:none"></div>
              <div class="s50 marking"><strong>50%</strong></div>
              <div class="s40 tick"><hr style="display:none"></div>
              <div class="s30 tick"><hr style="display:none"></div>
              <div class="s20 tick"><hr style="display:none"></div>
              <div class="s10 tick"><hr style="display:none"></div>
              <div class="s0 marking"><strong>0%</strong></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ['frame_no'],
  data () {
    return {
      range: '0'
    }
  },
  created () {
    this.updateRange()
  },
  methods: {
    ...mapActions([
      'asyncData'
    ]),
    updateRange () {
      this.asyncData({
        model: 'range',
        data: this.range
      })
    }
  },
  watch: {
  }
}
</script>
